export const getPattern = (multipleOf)=>{
    const decimals = getNumberOfDecimals(multipleOf);
    const regex = multipleOf === 1 || typeof multipleOf === 'undefined' || multipleOf === null ? `^-?\\d*?$` : `^-?\\d*(\\.\\d{0,${decimals}})?$`;
    return regex;
};
export const getNumberOfDecimals = (multipleOf)=>{
    return String(multipleOf).split('.')?.[1]?.length || 0;
};
export const getValidNumberInput = (input, multipleOf, previousValidValue, locale)=>{
    if (input.trim() === '') {
        return {
            validInput: '',
            validNumber: undefined
        }; // allow clear input
    }
    const inputNumber = toNumericValue(input);
    if (isNumberInputValid(inputNumber, multipleOf) && inputNumber !== undefined && inputNumber < Number.MAX_SAFE_INTEGER) {
        return {
            validInput: toLocaleDecimalSeparator(input, locale),
            validNumber: inputNumber
        };
    }
    return previousValidValue ? {
        validInput: previousValidValue,
        validNumber: toNumericValue(previousValidValue)
    } : {
        validInput: '',
        validNumber: undefined
    };
};
const getLocaleDecimalSeparator = (locale)=>locale ? Intl.NumberFormat(locale).formatToParts(1.1).find((part)=>part.type === 'decimal')?.value : undefined;
export const toLocaleDecimalSeparator = (input, locale)=>{
    const decimalSeparator = getLocaleDecimalSeparator(locale);
    return decimalSeparator ? input.replace(/[.,]/, decimalSeparator) : input;
};
export const isNumberInputValid = (value, multipleOf)=>{
    const multipleOfRegex = getPattern(multipleOf);
    const validator = new RegExp(multipleOfRegex);
    return validator.test(`${value}`);
};
export const toCanonicalDecimalSeparator = (value = '', locale)=>{
    const sep = getLocaleDecimalSeparator(locale);
    if (sep && sep !== '.' && sep !== ',') {
        value = value.replace(sep, '.');
    }
    return value.replace(',', '.');
};
export const toNumericValue = (value)=>{
    if (value === undefined || value === null || value === '') {
        return undefined;
    }
    const parsed = Number(toCanonicalDecimalSeparator(String(value)));
    return Number.isFinite(parsed) ? parsed : undefined;
};
export const isNumberInputPossible = (value = '', multipleOf)=>{
    if (multipleOf === 1 && value.indexOf('.') !== -1) {
        return false;
    } else if (value === '.' || value === '-') {
        return true;
    }
    return isNumberInputValid(Number(value), multipleOf);
};

//# sourceMappingURL=numeric-input-utils.js.map